module.exports = __webpack_public_path__ + "static/media/default-profile-banner.f11edc3a.jpg";